export default {
	supplymarketing: {
		title: 'Supply Chain Management',
		search_platform: 'Search platform',
		contact: 'Contact Information：',
		look_case: 'View more',
		entry_app: 'Apply',
	},
}
